const BASIC_URL = "https://back-end.elitesvs.mr-appss.com/api";

// const BASIC_URL = "http://192.168.0.201:8000/api";
const URL_Image = "https://back-end.elitesvs.mr-appss.com";
// const URL_Image = "http://192.168.0.201:8000";

const Config = {
  api: {
    Admin: {
      Login: `${BASIC_URL}/auth/login`,
      logout: `${BASIC_URL}/v1/cms/logout`,
      Password_change: `${BASIC_URL}/auth/password/change`,
      profile_update: `${BASIC_URL}/v1/cms/profile/update`,
      v1_profile: `${BASIC_URL}/v1/profile`,
      profile: `${BASIC_URL}/v1/profile`,
      Image: `${URL_Image}`,
    },
    Notifications: {
      v1_notifications: `${BASIC_URL}/v1/notifications`,
    },
    Users: {
      cms_admins: `${BASIC_URL}/v1/cms/admins`,
      v1_cms_users: `${BASIC_URL}/v1/cms/users`,
      v1_cms_users_block: `${BASIC_URL}/v1/cms/users/block`,
    },
    Category: {
      v1_cms_category: `${BASIC_URL}/v1/cms/category`,
    },
    Product: {
      v1_cms_product: `${BASIC_URL}/slider`,
    },
    Service: {
      admin_service_get: `${BASIC_URL}/service`,
      service_get: `${BASIC_URL}/service/get`,
      content_add: `${BASIC_URL}/content/add`,
      content_delete: `${BASIC_URL}/content/delete`,
      content_update: `${BASIC_URL}/content/update`,
    },
    Contact: {
      v1_cms_contact: `${BASIC_URL}/admin/contact`,
    },
    About: {
      admin_about_get: `${BASIC_URL}/about/get`,
      admin_about_update: `${BASIC_URL}/about/update`,
    },
  },
};
export const API = Config.api;
